export default __webpack_public_path__ + "static/media/19.5576eb3d.png";